/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon_service_whatap': {
    width: 24,
    height: 20,
    viewBox: '0 0 24 20',
    data: '<defs><path pid="0" d="M11 22V2h2.7v20H11zm-5.5 0V9h2.7v13H5.5zM0 22v-6h2.7v6H0zM16.4 2H24v2.7h-4.9V22h-2.7V2z" id="svgicon_icon_service_whatap_a"/></defs><g transform="translate(0 -2)" _fill="none" fill-rule="evenodd"><mask id="svgicon_icon_service_whatap_b" _fill="#fff"><use xlink:href="#svgicon_icon_service_whatap_a"/></mask><use _fill="#000" xlink:href="#svgicon_icon_service_whatap_a"/><g mask="url(#svgicon_icon_service_whatap_b)" _fill="#000"><path pid="1" d="M0 0h24v24H0z"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/components/icons/icon_service_whatap.js